module.exports = __webpack_public_path__ + "a8bb7c6f89b723f626c393c3df91a282.png";